import Link from "next/link";
import React from "react";
import ReactMarkdown from "react-markdown";

interface SimpleMarkdownProps {
  children: string;
  className?: string;
}

export const SimpleMarkdown: React.FC<SimpleMarkdownProps> = ({
  children,
  className,
}) => {
  if (!children || typeof children !== "string") {
    return <span className={className}>{children || ""}</span>;
  }

  return (
    <span className={className}>
      <ReactMarkdown
        components={{
          a: ({ href, children, ...props }) => {
            if (href && href.startsWith("/")) {
              return (
                <Link href={href} {...props}>
                  {children}
                </Link>
              );
            }
            return (
              <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                {...props}
              >
                {children}
              </a>
            );
          },
          p: ({ children }) => <span>{children}</span>,
        }}
      >
        {children}
      </ReactMarkdown>
    </span>
  );
};
